import { html } from 'lit-html';
import styles from './badge.styles.scss';
import WebComponent from 'utils/web-component';

const ComponentTagName = "ml-badge";

class BadgeComponent extends WebComponent {

  constructor() {
    super(styles, true, ComponentTagName);
  }

  onInit() { }

  onDestroy() { }

  static get observedAttributes() {
    return ['color', 'no-dot'];
  }

  get color() { return this.getAttribute('color'); }
  set color(value) { this.setAttribute('color', value); }

  // Sin la bolita de la izquierda (p. ej. las etiquetas de estado de Ecommerce).
  // Atributo booleano: web-component.js llama al setter con '' (puesto) o null (quitado)
  get noDot() { return this.hasAttribute('no-dot'); }
  set noDot(value) {
    if (value === null || value === false) this.removeAttribute('no-dot');
    else this.setAttribute('no-dot', '');
  }

  template() {
    const color = this.color ?? 'primary';

    return /* template */html`
      <div class="ml-badge ${color}">
        ${this.noDot ? '' : html`<span></span>`}
        <slot></slot>
      </div>
      `;
  }
}

window.customElements.define(ComponentTagName, BadgeComponent);
